import { useTranslation } from "react-i18next";
import submit from "submit-form";
import DateInput from "../../../../parts/inputs/date-input";
import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import { GettingStartedOption } from "../components/GettingStartedOption";
import { OptionCard } from "../components/OptionCard";
import { pullOptions, pushOptions } from "../data/getting-started";

export const GettingStarted = (_) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { _id, type, options, publishedAt } = locals.workflow;
  const access = locals?.query?.access ?? "push";
  const opts = access === "push" ? pushOptions : pullOptions;

  const onDateChange = (val) => {
    submit(`/actions/custom-workflows/set-published-at/${_id}`, {
      method: "POST",
      body: { publishedAt: val },
    });
  };

  return (
    <main className="getting-started">
      <header>
        <hgroup>
          <SvgIcon
            src="/img/new-icons/back-button.svg"
            onClickFn={() => {
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: { workflow: "", type: "" },
              });
            }}
          />
          <div>
            <h3>{t(`customWorkflows.workflowName.${type}`)}</h3>
          </div>
        </hgroup>
      </header>

      <div>
        <aside>
          <div className="flex justify-between items-center gap-2 mb-6">
            <h4>{t("customWorkflows.gettingStarted.listOfOptions")}</h4>
            <ToolTip
              id="options-tooltip"
              body={t("customWorkflows.gettingStarted.optionsTooltip")}
            >
              <SvgIcon
                alt={t("customWorkflows.gettingStarted.infoIconAlt")}
                src="/img/new-icons/question-circle.svg"
              />
            </ToolTip>
          </div>

          {Object.keys(opts).map((key) => (
            <GettingStartedOption
              key={options[key]?._id ?? key}
              option={key}
              optionObj={options[key]}
              workflow={_id}
            />
          ))}
        </aside>
        <section>
          {access === "pull" && (
            <article>
              <div>
                <p className="s2">
                  {t("customWorkflows.gettingStarted.effectiveStartDate")}
                </p>
                <p className="p5 mt-2">
                  {t(
                    "customWorkflows.gettingStarted.effectiveStartDateDescription",
                  )}
                </p>
              </div>
              <div>
                <DateInput
                  name="publishedAt"
                  value={publishedAt}
                  onChange={onDateChange}
                />
              </div>
            </article>
          )}
          {Object.keys(opts).map((key) => (
            <OptionCard
              key={`card-${options[key]?._id ?? key}`}
              option={key}
              optionObj={options[key]}
            />
          ))}
        </section>
      </div>
    </main>
  );
};
